import styled from '@emotion/styled';

import { linkWithUnderlineHover } from 'styles/mixins';
import { breakpoints } from '../../styles/basic';

const Wrapper = styled.div`
  p a {
    font-weight: bold;
    color: ${(props) => props.theme.mainColors.primary};
    ${(props) => linkWithUnderlineHover('&', 2, props.theme.mainColors.primary, 0)};
  }
`;

const TitleExtra = styled.span`
  text-transform: lowercase;
`;

const PersonDetailsWrapper = styled.div`
  display: flex;
  flex-flow: wrap row;
  justify-content: center;
  align-items: center;
  margin: 0 0 2rem;
  padding: 2rem;
  border-radius: .5rem;
  background: ${(props) => props.theme.color.gray};
  color: ${(props) => props.theme.mainColors.primary};

  table {
    margin-bottom: 0;
    td {
      border: 0;
    }
    tr td:first-of-type {
      text-align: right;
    }
  }

  @media (min-width: ${breakpoints.smallTablet}) {
    justify-content: flex-start;
  }
`;

const PhotoBox = styled.span`
  display: block;
  overflow: hidden;
  width: 17rem;
  height: 17rem;
  margin-right: 2rem;
  margin-bottom: 2rem;
  padding: .3rem;
  border: .3rem solid ${(props) => props.theme.mainColors.primary};
  border-radius: 50%;
  background: ${(props) => props.theme.colorMono.white};

  @media (min-width: ${breakpoints.smallTablet}) {
    width: 13rem;
    height: 13rem;
    margin-bottom: 0;
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    width: 17rem;
    height: 17rem;
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
`;

const SongArtWrapper = styled.div`
  & + & {
    margin-top: 2rem;
  }
  table {
    td {
      padding: 1rem;
      border: 0;
      line-height: 1.2;
      text-transform: uppercase;
      white-space: break-spaces;
      &:first-of-type {
        text-align: right;
      }
    }
    div {
      display: flex;
      align-items: center;
      gap: .5rem;
    }
    strong {
      font-size: 4rem;
      line-height: 1;
      color: ${(props) => props.theme.mainColors.primary};
    }
  }
`;

export {
  Wrapper,
  TitleExtra,
  PersonDetailsWrapper,
  PhotoBox,
  SongArtWrapper
};
